module.exports = __webpack_public_path__ + "static/16-6405afda3455d7fb6f4c82b47546b207.jpg";